import { Container, Row, Col, Modal } from "react-bootstrap";

export default function (props) {

    return (
        <Modal show={props.showModal} onHide={() => { props.setShowModal(false) }} centered>
            <div className="whole-container" style={{ textAlign: "center" }}>
                {props.player1Data && (
                    <>
                        <h1 className="container-title" style={{ color: '#BD00FF' }}>{"Joining " + props.player1Data.username}</h1>
                        <h1 className="container-body-text" style={{ color: '#FFFFFF' }}>Opening Deck Builder...</h1>
                    </>
                )}

                {props.player2Data && (
                    <>
                        <h1 className="container-title" style={{ color: '#BD00FF' }}>{props.player2Data.username + " has joined your game!"}</h1>
                        <h1 className="container-body-text" style={{ color: '#FFFFFF' }}>Opening Deck Builder...</h1>
                    </>
                )}
            </div>
        </Modal>
    )
}